<template>
  <div id="app" class="container m-auto text-gray-900">
    <notifications group="foo" position="top right" />

    <div
      class="flex md:flex-row flex-wrap flex-col justify-center md:justify-between items-center shadow-lg full-width px-10 bg-dark text-primary"
    >
      <div
        class="w-full md:w-auto flex justify-between md-:justify-start items-center text-xl md:text-4xl z-50"
      >
        <div class="py-4">
          <router-link to="/" class="flex items-center -mx-1">
            <img src="@/assets/img/logoGreen.svg" class="h-8 px-1" />
            <span class="text-xs px-1">v0.5 Beta</span>
          </router-link>
        </div>
        <div class="text-sm md:hidden" @click="toggleMenu">menu</div>
        <div class="hidden ml-6 md:flex -mx-3 items-center text-lg">
          <div class="px-3">
            <router-link to="/play">Play</router-link>
          </div>
          <div class="px-3">
            <router-link to="/bazaar">Bazaar</router-link>
          </div>
          <div class="px-3">
            <router-link to="/leaderboard">Gallery</router-link>
          </div>
          <div class="px-3">
            <router-link to="/wrap">Wrap</router-link>
          </div>

          <div class="px-3">
            <router-link to="/farm">Farm</router-link>
          </div>
          <div class="px-3">
            <router-link to="/stake">Stake LPs</router-link>
          </div>
          <div class="px-3">
            <router-link to="/race">Race 🏎️</router-link>
          </div>

          <!-- <div class="px-3">
            <a href="http://docs.verynifty.io" target="_blank">Learn</a>
          </div> -->
        </div>
      </div>
      <div class="hidden md:flex flex -mx-3 items-center text-lg">
        <div class="px-3">
          <TokenBalance
            :erc20="MuseToken"
            :account="account"
            symbol="$MUSE"
            decimals="18"
          />
        </div>
        <!-- <div class="px-3">
          <a href>
            <EthBalance :account="account" />
          </a>
        </div> -->

        <div class="px-3">
          <Address :address="account" />
        </div>
        <!-- <div class="toggle-market cursor-pointer px-3">
          <img src="assets/img/brush.svg" alt class="h-12" />
        </div>-->
      </div>
      <div
        class="w-full md:hidden"
        id="mobile-menu"
        v-if="menuActive"
        @click="toggleMenu"
      >
        <ul>
          <li class="mt-2"><Address :address="account" /></li>
          <li class="mt-2">
            <TokenBalance
              :erc20="MuseToken"
              :account="account"
              symbol="$MUSE"
              decimals="18"
            />
          </li>
          <!-- <li class="mt-2">
            <EthBalance :account="account" />
          </li> -->

          <li class="mt-2"><router-link to="/play">Play</router-link></li>
          <li class="mt-2"><router-link to="/bazaar">Bazaar</router-link></li>

          <li class="mt-2">
            <router-link to="/leaderboard">Gallery</router-link>
          </li>
          <li class="mt-2"><router-link to="/race">Race 🏎️</router-link></li>

          <li class="mt-2"><router-link to="/wrap">Wrap</router-link></li>
          <li class="mt-2"><router-link to="/farm">Farm</router-link></li>
          <li class="mt-2"><router-link to="/stake">Stake Lps</router-link></li>
          <li class="mt-2">
            <a
              href="https://medium.com/@verynifty/very-nifty-museum-faqs-d16eea2b224c"
              target="_blank"
              >FAQs</a
            >
          </li>
        </ul>
      </div>
    </div>
    <div class="container m-auto text-gray-900"></div>
    <router-view />
    <Footer />
  </div>
</template>

<script>
import TokenBalance from "@/components/TokenBalance.vue";
import EthBalance from "@/components/EthBalance.vue";
import Address from "@/components/Address.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "App",
  components: { TokenBalance, EthBalance, Address, Footer },
  data: function () {
    return {
      menuActive: false,
    };
  },
  props: {},
  beforeMount: function () {
    if (this.$web3Modal.providerController.cachedProvider != null) {
      console.log(
        "Connecting back to: ",
        this.$web3Modal.providerController.cachedProvider
      );
      this.$store.dispatch("connectWallet", this);
    }
  },
  computed: {
    account: function () {
      return this.$store.state.account;
    },
    MuseToken: function () {
      return this.$store.state.contracts.MuseToken;
    },
  },
  methods: {
    toggleMenu: function () {
      this.menuActive = !this.menuActive;
      // some code to filter users
    },
  },
};
</script>

<style></style>
